export function getRuntimeEnvironmentVariable(
  name: string,
  fallbackName?: string
): string | undefined {
  return (
    process.env[name] || (fallbackName ? process.env[fallbackName] : undefined)
  );
}
